<template lang="html">
  <div class="row-edit no-margin track">
    <div class="row-edit-badge-section">
      <div class="row-edit-badge">

          <div class="float-left w220">
            <label>{{$t('INDENT_INDENTED_VEHICLE')}}</label>
            <span class="track-text">{{order.vehicle_type.name}}</span>
          </div>
          <div class="float-left w220">
            <div  v-if='showChangeRequestedVehicle'>
              <label>{{$t('INDENT_CHANGE_REQUESTED')}}</label>
              <span class="track-text">{{order.flow.change_vehicle_type_id.name}}</span>
            </div>
          </div>
        </div>
        <div class="row-edit-badge">

          <label>{{$t('INDENT_COMMENTS')}}</label>
          <div class="commentarea">
           <div class="timeline-comment">
            <div class="content">
             <!-- <div class="content-item">
              <div class="dot dot-indent"></div>
             </div> -->
             <div class="content-body" v-for="(comment, index) in changeTruckComments" :key="index">
              <div class="content-body-status">
               <p class="content-item-title"> {{comment.user.name}}</p>
               <p class="content-item-primary"> {{comment.comment}}</p>
              <p class="content-item-sec"> {{comment.created_date |  moment("DD MMM YYYY")}} </p>
              </div>
             </div>
            </div>
           </div>
         </div>
    </div>
    <div class="row-edit-badge" v-if="$hasFeature('show_sob_utilization_details')">
      <div class="track-text">
        <p><strong>{{$t('SOB_EXISTS')}}:</strong> {{ sobDetails.runningSOB }}%</p>
        <p><strong>{{$t('SOB_ESTIMATED')}}:</strong> {{ sobDetails.idealSOB }}%</p>
        <p><strong>{{$t('BASE_FREIGHT')}}:</strong> {{ sobDetails.baseFreight }}</p>
        <p><strong>{{$t('BASE_FREIGHT_UNIT')}}:</strong> {{ $t(sobDetails.freightUnit) }}</p>
      </div>
    </div>

    <div v-if="order.flow.change_hilly_region">
      <svgicon name="icon-info-circle" width="12" height="12" :original="true"/>
      <label for="hilly_region">{{$t('INDENT_ACCEPT_HILLY_REQUEST')}}</label>
    </div>

    <div class="popover-primary-footer">
      <div class="action">
        <button class="btn btn-secondary re-indent" @click="$emit('re-indent')">
          {{$t('INDENT_RE_INDENT')}}
        </button>
        <button class="btn-primary accept" @click="$emit('accept')">{{$t('INDENT_ACCEPT')}}</button>
        <button class="btn-primary accept" @click="$emit('continue')">{{$t('INDENT_CONTINUE')}}</button>
      </div>
    </div>

    </div>
  </div>
</template>
<script>
import {
  mapState,
} from 'vuex';

export default {
  name: 'TruckChangeRequest',
  props: {
    order: Object,
    sob: {
      data: {
        ideal_sob_percentage: '',
        running_sob_percentage: '',
        freight_rate: '',
        freight_unit: '',
      },
    },
  },
  computed: mapState({
  // arrow functions can make the code very succinct!
    changeTruckComments: state => state.order.changeTruckComments,
    showChangeRequestedVehicle() {
      // CURRENT & CHANGED vehicle are same.
      return this.order.flow.change_vehicle_type_id.id !== this.order.vehicle_type.id;
    },
    sobDetails() {
      return {
        idealSOB: this.sob && this.sob.data && this.sob.data.ideal_sob_percentage ? this.sob.data.ideal_sob_percentage : 0,
        runningSOB: this.sob && this.sob.data && this.sob.data.running_sob_percentage ? this.sob.data.running_sob_percentage : 0,
        baseFreight: this.sob && this.sob.data && this.sob.data.freight_rate ? this.sob.data.freight_rate : 0,
        freightUnit: this.sob && this.sob.data && this.sob.data.freight_unit ? this.sob.data.freight_unit : '',
      };
    },
  }),
};
</script>
